export default __webpack_public_path__ + "static/media/personas-hero.4f23188f.jpg";